import PropTypes from "prop-types";
import React from "react";

//import Button from "./shared/Button";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import OberflexImage from "../images/collections/oberflex.jpg";
import MarotteImage from "../images/collections/marotte.jpg";
import PurePaperColorImage from "../images/collections/purepapercolor.jpg";
import PurePaperMetalImage from "../images/collections/purepapermetal.jpg";

import LogoOberflex from "../images/brands/oberflex.svg";
import LogoMarotte from "../images/brands/marotte.svg";
import LogoPurePaper from "../images/brands/purepaper-metal.svg";
import LogoPurePaperMetal from "../images/brands/purepaper.svg";

const CollectionsList = props => (
  <React.Fragment>
    <section className="grid grid--2 grid--fixed" style={{ top: "55px" }}>
      <LocalizedLink className="grid__item" to="/collections/surfaces">
        <div className="grid__item-title font-bold">{props.t("titleSurfaces")}</div>
      </LocalizedLink>
      <LocalizedLink className="grid__item" to="/collections/patterns">
        <div className="grid__item-title">{props.t("titlePatterns")}</div>
      </LocalizedLink>
    </section>

    <section
      className="w-100 flex items-center pv8"
      style={{ marginTop: "104px" }}
    >
      <div className="center tc f2 font-light">
        {props.t("pageintroduction1")}<br/>
        {props.t("pageintroduction2")}
      </div>
    </section>

    <section className="grid grid--4 bt">
      <div
        className="grid__item"
        style={{ backgroundImage: `url(${OberflexImage})` }}
      >
        <div className="grid__item-image">
          <img
            className="grid__item-svg grid__item-svg--oberflex"
            src={LogoOberflex}
            alt="Oberflex"
          />
        </div>
        <div className="grid__item-label">
          <div className="grid__item-text">
          {props.t("oberflexDescription")}
          </div>
          <a
            className="button"
            href="http://www.oberflex.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            oberflex.com
          </a>
          {/*
          <Button
            external
            label="oberflex.com"
            link="http://www.oberflex.com/"
          />
          */}
        </div>
      </div>
      <div
        className="grid__item"
        style={{ backgroundImage: `url(${MarotteImage})` }}
      >
        <div className="grid__item-image">
          <img
            className="grid__item-svg grid__item-svg--marotte"
            src={LogoMarotte}
            alt="Marotte"
          />
        </div>
        <div className="grid__item-label">
          <div className="grid__item-text">
          {props.t("marotteDescription")}
          </div>
          <a
            className="button"
            href="http://www.marotte.fr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            marotte.fr
          </a>

          {/*<Button external label="marotte.fr" link="http://www.marotte.fr/" />*/}
        </div>
      </div>
      <div
        className="grid__item"
        style={{ backgroundImage: `url(${PurePaperColorImage})` }}
      >
        <div className="grid__item-image">
          <img
            className="grid__item-svg grid__item-svg--purepaper"
            src={LogoPurePaper}
            alt="Pure Paper Color"
          />
        </div>
        <div className="grid__item-label">
          <div className="grid__item-text">
          {props.t("purepaperColorDescription")}
          </div>
          <a
            className="button"
            href="http://www.purepaper-laminates.com/color-collection-de-surfaces-decoratives.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            purepaper-laminates.com
          </a>
{/*
          <Button
            external
            label="purepaper-laminates.com"
            link="http://www.purepaper-laminates.com/color-collection-de-surfaces-decoratives.html"
          />
*/}
        </div>
      </div>
      <div
        className="grid__item"
        style={{ backgroundImage: `url(${PurePaperMetalImage})` }}
      >
        <div className="grid__item-image">
          <img
            className="grid__item-svg grid__item-svg--purepapermetal"
            src={LogoPurePaperMetal}
            alt="Pure Paper Metal"
          />
        </div>
        <div className="grid__item-label">
          <div className="grid__item-text">
          {props.t("purepaperMetalDescription")}
          </div>

          <a
            className="button"
            href="http://www.purepaper-laminates.com/metal-collection-de-surfaces-decoratives.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            purepaper-laminates.com
          </a>

  {/*
          <Button
            external
            label="purepaper-laminates.com"
            link="http://www.purepaper-laminates.com/metal-collection-de-surfaces-decoratives.html"
          />
*/}
        </div>
      </div>
    </section>

    <Footer t={props.t} />
  </React.Fragment>
);

CollectionsList.propTypes = {
  surfaces: PropTypes.array,
  collections: PropTypes.array
};

export default CollectionsList;



// WEBPACK FOOTER //
// ./src/components/CollectionsList.js